import React from "react";
import { Modal, Button } from "antd";

const DeletePremadeDialog = ({ open, onClose, onDelete }) => {
  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Modal
      title="Confirm Delete"
      open={open}
      onCancel={onClose}
      width="auto"
      style={{ maxWidth: "400px" }}
      zIndex={1300}
      centered
      getContainer={() => {
        const mainContent = document.querySelector('main[component="main"]') ||
                           document.querySelector('main') ||
                           document.body;
        return mainContent;
      }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="delete" type="primary" danger onClick={handleDelete}>
          Delete
        </Button>,
      ]}
    >
      <p>Are you sure you want to delete this item?</p>
    </Modal>
  );
};

export default DeletePremadeDialog;
